<template>
  <section class="artAI-section">
    <div id="chatContainer" class="artAI-container">
      <div class="artAI-header">Art with Blitzar: {{ credits }}</div>
      <div class="artAI-body">
        <div class="artAI-input-box">
          <select class="artAI-styles-select" @change="handleStyleSelected">
            <option value="" disabled selected>Escolha um estilo</option>
            <option v-for="item in styles" :key="item.art_style_id" :value="item.art_style_id">{{ item.style }}</option>
          </select>
          <i class="fas fa-trash-alt" @click="deleteCurrentStyle()" v-if="currentStyleID"></i>
        </div>
        <div class="artAI-buttons" v-if="userPrompt">
          <input class="input-alt" type="text" v-model="styleName" placeholder="Nome do novo estilo" />
          <button class="btn" @click.capture="postStyle()" v-if="styleName">Guardar Estilo</button>
        </div>
        <div class="artAI-input-container">
          <input v-model="userPrompt" @keydown.enter="generate" id="inputBoxPrompt" class="artAI-input-box" placeholder="Crie sua arte" />
          <input v-model="userURL" @keydown.enter="generate" id="inputBoxURL" class="artAI-input-box" placeholder="URL de imagem de refrência" />
          <input v-model="userImageWeight" v-if="userURL" @keydown.enter="generate" id="inputBoxImageWeight" class="artAI-input-box" placeholder="Image weight (0-1) [default = 0.4] " />
          <input v-model="userCFG" @keydown.enter="generate" id="inputBoxCFG" class="artAI-input-box" placeholder="CFG (0-20) [default = 7]" />
          <input v-model="userSteps" @keydown.enter="generate" id="inputBoxSteps" class="artAI-input-box" placeholder="Steps (10-150) [default = 15]" />
          <input v-model="userWeight" @keydown.enter="generate" id="inputBoxWeight" class="artAI-input-box" placeholder="Text weight (0-1) [default = 1.0]" />
          <select class="artAI-input-box" v-model="samplerSelected">
            <option value="" key="0" selected>Sampler</option>
            <option v-for="sampler in samplers" :value="sampler" :key="sampler">
              {{ sampler }}
            </option>
          </select>
          <select class="artAI-input-box" v-model="clipGuidancePresetSelected">
            <option value="" key="0" selected>Clip Guidance Preset</option>
            <option v-for="clip in clipGuidancePresetList" :value="clip" :key="clip">
              {{ clip }}
            </option>
          </select>
          <input v-model="userSeed" @keydown.enter="generate" id="inputBoxSeed" class="artAI-input-box" placeholder="Seed [default = random]" />
          <select class="artAI-input-box" v-model="engineSelected">
            <option value="" key="0" selected>Engine</option>
            <option v-for="engine in engines" :value="engine.id" :key="engine.id">
              {{ engine.name }}
            </option>
          </select>
          <button @click="generate" class="artAI-send-button">Gerar Arte</button>
        </div>
        <!-- <div>
            <h4>IMAGEM:</h4>
            <img class="artAI-image" :src="imgArtAI.src" v-if="imgArtAI.src && !showSpinner">
          </div>           -->
      </div>
    </div>

    <div>
      <h4>IMAGEM:</h4>
      <img class="artAI-image" :src="imgArtAI.src" v-if="imgArtAI.src && !showSpinner" />
    </div>

    <Spinner :showSpinner="showSpinner" />
  </section>
</template>
<script>
import api from '@/services/api';
import Spinner from '@/components/ui/Spinner.vue';

export default {
  name: 'ArtAI',
  components: { Spinner },
  data() {
    return {
      userPrompt: '',
      userURL: '',
      userCFG: null,
      userSteps: null,
      userWeight: null,
      userImageWeight: null,
      userSeed: null,
      showSpinner: false,
      imgArtAI: new Image(),
      engines: {},
      engineSelected: null,
      samplers: {},
      samplerSelected: null,
      styles: [],
      clipGuidancePresetList: {},
      clipGuidancePresetSelected: null,
      credits: 0,
      styleName: '',
      currentStyleID: null,
    };
  },
  computed: {
    currentSettings() {
      return {
        idea: this.userPrompt,
        url: this.userURL,
        cfg_scale: this.userCFG,
        steps: this.userSteps,
        weight: this.userWeight,
        image_strength: this.userImageWeight,
        engine: this.engineSelected,
        sampler: this.samplerSelected,
        clip_guidance_preset: this.clipGuidancePresetSelected,
        seed: this.userSeed,
      };
    },
  },
  methods: {
    async generate() {
      try {
        this.showSpinner = true;
        let response = null;
        let query = `idea=${this.userPrompt}`;
        query = this.userURL ? query + `&url=${this.userURL}` : query;
        query = this.userCFG ? query + `&cfg_scale=${this.userCFG}` : query;
        query = this.userSteps ? query + `&steps=${this.userSteps}` : query;
        query = this.userWeight ? query + `&weight=${this.userWeight}` : query;
        query = this.userURL && this.userImageWeight ? query + `&image_strength=${this.userImageWeight}` : query;
        query = this.engineSelected ? query + `&engine=${this.engineSelected}` : query;
        query = this.samplerSelected ? query + `&sampler=${this.samplerSelected}` : query;
        query = this.clipGuidancePresetSelected ? query + `&clip_guidance_preset=${this.clipGuidancePresetSelected}` : query;
        query = this.seed ? query + `&seed=${this.userSeed}` : query;
        console.log('Query:', query);
        if (!this.userURL) {
          // Use the artAI API to generate a response
          response = await fetch(`https://art.blitzar.com.br/api/create?${query}`);
        } else {
          response = await fetch(`https://art.blitzar.com.br/api/edit?${query}`);
        }
        // Read the response body as a string
        const responseBody = await response.text();

        console.log('Response:', responseBody);
        // Parse the response body as JSON
        const responseData = JSON.parse(responseBody);

        // Base64-encoded PNG image data — use browser-native Uint8Array → btoa()
        const bytes = new Uint8Array(responseData?.image?.data);
        const binary = bytes.reduce((acc, byte) => acc + String.fromCharCode(byte), '');
        const base64Img = btoa(binary);
        const base64Src = `data:image/png;base64,${base64Img}`;
        // Create new image element
        //this.imgArtAI = new Image();

        // Set source to base64 data
        this.imgArtAI.src = base64Src;
        this.showSpinner = false;
        this.checkCredits();
      } catch (error) {
        console.error(error);
        this.showSpinner = false;
      }
    },
    async loadEngines() {
      const response = await fetch(`https://art.blitzar.com.br/api/engine`);
      const responseBody = await response.text();

      console.log('Response:', responseBody);
      // Parse the response body as JSON
      this.engines = JSON.parse(responseBody);
      console.log('Engines:', this.engines);
    },
    async loadSamplers() {
      const response = await fetch(`https://art.blitzar.com.br/api/sampler_list`);
      const responseBody = await response.text();

      console.log('Response:', responseBody);
      // Parse the response body as JSON
      try {
        const temp = JSON.parse(responseBody);
        this.samplers = temp.sampler_list;
      } catch (error) {
        console.log(error);
      }
      console.log('Samplers:', this.samplers);
    },
    async loadClipGuidancePreset() {
      const response = await fetch(`https://art.blitzar.com.br/api/clip_guidance_preset_list`);
      const responseBody = await response.text();

      console.log('Response:', responseBody);
      // Parse the response body as JSON
      try {
        const temp = JSON.parse(responseBody);
        this.clipGuidancePresetList = temp.clip_guidance_preset_list;
      } catch (error) {
        console.log(error);
      }
      console.log('clipGuidancePresetList:', this.clipGuidancePresetList);
    },
    async checkCredits() {
      const response = await fetch(`https://art.blitzar.com.br/api/balance`);
      const responseBody = await response.text();

      console.log('Response:', responseBody);
      // Parse the response body as JSON
      const { credits } = JSON.parse(responseBody);
      this.credits = credits;
      console.log('Credits:', credits);
    },
    async loadStyles() {
      const response = await api.get(`/artStyle/`);
      console.log('Response:', response.data);
      this.styles = response.data.map((style) => {
        try {
          style.properties = JSON.parse(style.properties);
        } catch (error) {
          console.error(error);
        }
        return style;
      });
    },
    handleStyleSelected(e) {
      const art_style_id = e.target.value;
      this.currentStyleID = art_style_id;

      const style = this.styles.find((style) => style.art_style_id === art_style_id);
      const props = style.properties;

      this.userPrompt = props.idea;
      this.userURL = props.url;
      this.userCFG = props.cfg_scale;
      this.userSteps = props.steps;
      this.userWeight = props.weight;
      this.userImageWeight = props.image_strength;
      this.engineSelected = props.engine;
      this.samplerSelected = props.sampler;
      this.clipGuidancePresetSelected = props.clip_guidance_preset;
      this.userSeed = props.seed;
    },
    postStyle() {
      api
        .post(`/artStyle/`, {
          style: this.styleName,
          config: JSON.stringify({ prompt: this.userPrompt }),
          properties: JSON.stringify(this.currentSettings),
        })
        .then((response) => {
          console.log('postArtAIStyle', response);
          this.styleName = '';
          this.loadStyles();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteCurrentStyle() {
      api
        .delete(`/artStyle/${this.currentStyleID}`)
        .then((response) => {
          console.log('deleteCurrentStyle', response);
          this.loadStyles();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeMount() {
    this.loadStyles();
    this.loadEngines();
    this.loadSamplers();
    this.loadClipGuidancePreset();
    this.checkCredits();
  },
};
</script>
<style lang="scss">
.artAI-section {
  position: relative;
  padding: 10%;
  z-index: 10000;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;

  pointer-events: none;

  .artAI-container {
    position: relative;
    width: 400px;
    // background-color: #f5f5f5;
    border-radius: 8px;
    overflow: hidden;

    pointer-events: auto;
  }

  .artAI-header {
    padding: 16px;
    background-color: #2196f3;
    color: white;
    text-align: center;
    font-size: 20px;
  }

  .artAI-body {
    display: flex;
    flex-direction: column;
    // height: calc(100% - 56px);
  }

  .artAI-messages {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
  }

  .artAI-message {
    display: flex;
    align-items: flex-start;
    margin-bottom: 8px;
  }

  .artAI-message-text {
    // background-color: #e0e0e0;
    padding: 8px;
    border-radius: 8px;
    font-size: 14px;
  }

  .artAI-input-container {
    padding: 8px 16px;
    background-color: #f5f5f5;

    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }

  .artAI-input-box {
    width: 100%;
    padding: 8px;
    border-radius: 8px;
    border: none;
    font-size: 14px;

    display: flex;

    .artAI-styles-select {
      position: relative;
      flex-grow: 1;
    }
  }

  .artAI-send-button {
    margin-left: 8px;
    padding: 8px 16px;
    border-radius: 8px;
    background-color: #2196f3;
    color: white;
    font-size: 14px;
    cursor: pointer;
  }

  .artAI-send-button:hover {
    background-color: #1e88e5;
  }

  .artAI-image {
    width: 100%;
    height: 100%;
    max-width: 400px;
  }
  .artAI-buttons {
    display: flex;
    justify-content: space-between;
  }
}
</style>
